import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'react-router-dom';


import 'swiper/css';



import { Autoplay } from 'swiper/modules';

export default function HomeBanner() {
    return (
        <>
            <Swiper
                spaceBetween={30}
                centeredSlides={true}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}


                modules={[Autoplay]}
                className="mySwiper "
                style={{ marginTop: "-32px" }}
            >

                <SwiperSlide>
                    <div className="">
                        <img src="assets/img/banner_1.webp" alt="education" className="img-fluid" />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="">
                        <img src="assets/img/banner_2.webp" alt="education" className="img-fluid" />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="">
                        <img src="assets/img/banner_3.webp" alt="education" className="img-fluid" />
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="">
                        <img src="assets/img/banner_4.webp" alt="education" className="img-fluid" />
                    </div>
                </SwiperSlide>
               



            </Swiper>
        </>
    );
}
